
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91action_93x6uN2aithcFVSWd8Gi2tjxUCqJQx87lgD7BhglM0o3IMeta } from "/vercel/path0/apps/zefire-spa/pages/auth/[action].vue?macro=true";
import { default as auth6zPukhueMeSa91YqGYymlwoPPwjM6av_45XXoCUA9_45v3YMeta } from "/vercel/path0/apps/zefire-spa/pages/auth.vue?macro=true";
import { default as errorpyOG4L79B1TohYxt0Utn6s0GVK_45MKgmtE4JWPvLCudAMeta } from "/vercel/path0/apps/zefire-spa/pages/error.vue?macro=true";
import { default as releasesD7Tabir9XPWlVtB_45VEyPQz0Mg9Xnp1OjwgRNzXapxWoMeta } from "/vercel/path0/apps/zefire-spa/pages/releases.vue?macro=true";
import { default as settingsgGmu0TNotA8b2_wgp1njhdr6t8bz8RP_45nGDjLF_45HBtgMeta } from "/vercel/path0/apps/zefire-spa/pages/settings.vue?macro=true";
import { default as filesIg6sAzck8i4U0KfETdAbN_gIGIpV16Ytf4c4_45GD1XHgMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/files.vue?macro=true";
import { default as indexiIkL6O36ja4AwvEfpKm6kR0BpQgzSHPBBOEsJo6m_sQMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/index.vue?macro=true";
import { default as notestrSoePXuXQ9U8ZPNzPl6GlyTZiG19z_hLVjZdFQB9y0Meta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/notes.vue?macro=true";
import { default as invoicescYXGxcNw52JmdEBfTxW0A_45p7vVbhVRKRgXSe6yQfa8cMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/invoices.vue?macro=true";
import { default as contractswz_X4k9_45GUClR2KbB5jiCVVxBAw8mKKGKhl6eM_45kDnkMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/contracts.vue?macro=true";
import { default as portfolioStHW4C0Z0v61pB5ZWH1bwAQPQ1sKSFBOogXVxv7sv7EMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/portfolio.vue?macro=true";
import { default as datahealthgM8f18NpPue1Yx0WCBSS326FS1JjJ_VL3iKy2FQ2aW4Meta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/datahealth.vue?macro=true";
import { default as supervisionyQ2oCimsz8El7sgveLuTFFbIIoh2eRouPWJKd_45ACIpcMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/supervision.vue?macro=true";
import { default as _91aggregation_93_1SpDbAi5lWdzrV3h8l49mwdny8SMmP_45q_45b_6Sd2kuEMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/[aggregation].vue?macro=true";
import { default as calendar_45_91view_93zKV0DRglaFKgP_OKG29BUaDlnvE9_45vOvWL_4543Y6I5HEMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/calendar-[view].vue?macro=true";
import { default as _91uuid_93n7UE7c_cgEDcGrcLvnFOMqOa_45qKalm26_452HUn8Nxs24Meta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid].vue?macro=true";
import { default as _91kind_93WztR_igRRMvWyhM95NFW7lXrCGpmq41wMKPbnbNmfkgMeta } from "/vercel/path0/apps/zefire-spa/pages/companies/[kind].vue?macro=true";
import { default as companiesw8_pxiJnPwpLlOD6mnm0RaEYDzsUprL0515YUcLRBO4Meta } from "/vercel/path0/apps/zefire-spa/pages/companies.vue?macro=true";
import { default as index1WV5dLjFGSTHSZLJDATLsjwLvzWqQGFgOAqEpGylls4Meta } from "/vercel/path0/apps/zefire-spa/pages/contracts/index.vue?macro=true";
import { default as filesosiVw0DgVPYqzTeybXCeCaBRvaDcvHmss_J_HoZpAEUMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/files.vue?macro=true";
import { default as indexeiw_45eD0Pof0S4a_xaAw0Ark1sJXOCwxdhDEIc0fr1QoMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/index.vue?macro=true";
import { default as notesrfgptyMQRPySzE6UIqxfa1T0nbwLjgXR8K20v24SEMUMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/notes.vue?macro=true";
import { default as invoicesmef8MdUJyJNn82_45bPM1_WHOhuG483rD0PCerlQqqr8QMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/invoices.vue?macro=true";
import { default as supply_45invoicesqJAI5_3TTxTsxZQLnLtgpnum9XBiRau6iKYND78G2uAMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/supply-invoices.vue?macro=true";
import { default as _91uuid_93W9VrRIgzywV7ZfTWH4V9Zpu7VzqjhXaU277O29hB0bYMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts/[uuid].vue?macro=true";
import { default as contractsmYTrF_zcLrvEDtYZZM_CwwWRmY_tim5FcqDG5bH878sMeta } from "/vercel/path0/apps/zefire-spa/pages/contracts.vue?macro=true";
import { default as files14eb6u7WCAcJcGSX5DgltKemE1A0OifbxHzT9EUJTaYMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/files.vue?macro=true";
import { default as indexpE6Mb607Ytj9_45FrxNydCZwAXdM9OIpnUWvGQcOgVJPUMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/index.vue?macro=true";
import { default as notesQwb9XEL0N_i9qZWKQ_45EmYfpu8A28IpQinwo0aV7o46EMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/notes.vue?macro=true";
import { default as marketZHkiyQU4dztNYxbW_45vl2OXFEMYYI3wVweMPG430k3UYMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/market.vue?macro=true";
import { default as technoquGUQH27u9SsG3RsERvBtGMeDB4JhP6XLoDQN9WJQq4Meta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/techno.vue?macro=true";
import { default as datahealthUE4YpdIltDtyJQMvY_lw_456svx5d2WSj36btK_45CAgR8MMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/datahealth.vue?macro=true";
import { default as supervisionQBuBjWvDVfFbS347RNl9eoJmSj4LERmLiO1IYw8dtzMMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/supervision.vue?macro=true";
import { default as calendar_45_91view_93Uq5tJrtGJFLVqxEDn90GLAgOYbb_z9ICraYkat_bdiUMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard/calendar-[view].vue?macro=true";
import { default as dashboardQ7IeIdoF2_45_45tEjeRKHvNPUvKbog2IALONuw0eHHNWhkMeta } from "/vercel/path0/apps/zefire-spa/pages/dashboard.vue?macro=true";
import { default as index29AEJMIWfjXxIDOpKw5nwTaYrWFjT9oK_45_4IALnd_45H0Meta } from "/vercel/path0/apps/zefire-spa/pages/invoicing/index.vue?macro=true";
import { default as invoicesayT315h5VV4UFlE7VXxw4gFar7BGAXGvmbojooYZG9MMeta } from "/vercel/path0/apps/zefire-spa/pages/invoicing/invoices.vue?macro=true";
import { default as recoveryzNU9UEtUkWc_ht7w7vxCyjrqy_JMrP9gjjlyM1aMs4UMeta } from "/vercel/path0/apps/zefire-spa/pages/invoicing/recovery.vue?macro=true";
import { default as validationQcAfm5Wfe4dydEkb2_BYLt_45Xi3v0luuxQ92SUzZyTQIMeta } from "/vercel/path0/apps/zefire-spa/pages/invoicing/validation.vue?macro=true";
import { default as invoicingxOFO9sq_kVjWpie9eVu9oYDM9pFZoy_45_457pZl2_45v_451GQMeta } from "/vercel/path0/apps/zefire-spa/pages/invoicing.vue?macro=true";
import { default as indexKuWKWE9VlVmstfdql7ioXb_45NrWmktlG56ufnGz8YWnoMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/index.vue?macro=true";
import { default as filesiZKXpHE8XTGjN3ZuYqPgPSNJi46GxXhTPmLvwUfo8lUMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/files.vue?macro=true";
import { default as indexc_45E9aJ7iynOFAZCwiP_0xFJUd1_45Yi3tfGwgwy7nCJR4Meta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/index.vue?macro=true";
import { default as notesMFE8Nh3BD_JIwjbokrCCkS2zPrFhkuP9ULKi6hqEm2kMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/notes.vue?macro=true";
import { default as assetsWiIJqfLYfOyw_45gVUkQmcbixarzsT5GlfF80_45WXr5_8IMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/assets.vue?macro=true";
import { default as invoicesAPrK9Oo5fEbS_45ue3CJXiVxKH2m_45GajlNAO_T3d62JbIMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/invoices.vue?macro=true";
import { default as contracts7bU_45e0gdsHGIRgxodF0MixummErM2_gPm5ckMg5poMEMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/contracts.vue?macro=true";
import { default as datahealthEEsRKBrl6LG6yh1Iy5vUA4BOWIXViYK0PwI8aOUIa3AMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/datahealth.vue?macro=true";
import { default as datastatusPhK2CelC4ih4NcepcskiT654azTBWeOL41pf7wzknuAMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/datastatus.vue?macro=true";
import { default as supervision4nfP9tc_45ABIkSPA_45Lpr_RZmbxg_45K1qRMWndk1rYVSrIMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/supervision.vue?macro=true";
import { default as calendar_45_91view_9343_HfezvrDS7xaAWK6QrRmalsG55TdZB0X1uXGCweREMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/calendar-[view].vue?macro=true";
import { default as supply_45invoicesyFFan_k7Z_wpYQ6_45403SyjJnuov4_45Z3LWZZEucWZz9YMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/supply-invoices.vue?macro=true";
import { default as _91uuid_93wtg3Pn6OSh7ml4sBOw0xI5rq2__g2ANDY_45pW6vPb_458oMeta } from "/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid].vue?macro=true";
import { default as portfolioRlWsfzRe3jJdk3DHoOSHnqV36lh1AeuDa_J75CMCgR8Meta } from "/vercel/path0/apps/zefire-spa/pages/portfolio.vue?macro=true";
import { default as datastudiolJf0_450wjsEPumffG1zElW7Y0Ur7FUQLSPisBbccO1NoMeta } from "/vercel/path0/apps/zefire-spa/pages/datastudio.vue?macro=true";
import { default as ui_45testingEXYvUNmJxYctMxqc5zHl_45y2TA_cncxwx8cVwXRqIJ80Meta } from "/vercel/path0/apps/zefire-spa/pages/ui-testing.vue?macro=true";
import { default as index45BwUNnDYjJdKu8dcueqr2OsFPf4tS2jQzDHWwuhlj4Meta } from "/vercel/path0/apps/zefire-spa/pages/marketplace/index.vue?macro=true";
import { default as counterpartsG_45qctZ_45ZOrNO1RIf7uOHrg_wKJvPSa9cNUPXEx95aTQMeta } from "/vercel/path0/apps/zefire-spa/pages/marketplace/counterparts.vue?macro=true";
import { default as marketplaceT2KBnNIzYsojjg2HFmFGmeaAfcQZ9J93Uzx4NgHPEBYMeta } from "/vercel/path0/apps/zefire-spa/pages/marketplace.vue?macro=true";
import { default as indexhhVGKMA1vNTfqR3HYZsSrqmHBuCPeFGAZ2M8RRKA7cQMeta } from "/vercel/path0/apps/zefire-spa/pages/commissioning/index.vue?macro=true";
import { default as reservesAv53RdW4YU_45NyY6y_45wM_45NVNNLfbD8yRese0zwqXJhbIMeta } from "/vercel/path0/apps/zefire-spa/pages/commissioning/reserves.vue?macro=true";
import { default as commissioning47Vn0MNdQTpgx25FSYvTIMsiM6vT207WN9RfTc2S7H0Meta } from "/vercel/path0/apps/zefire-spa/pages/commissioning.vue?macro=true";
import { default as indexET7Kmiwzj8kIbZECU54hL0SrNYR612LDZANXMnaEUekMeta } from "/vercel/path0/apps/zefire-spa/pages/invoices/index.vue?macro=true";
import { default as filesTyuxjG1CTOlsTvHfoOkAtq5WHLL2DejapuYYlnveyK0Meta } from "/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/files.vue?macro=true";
import { default as indexO4mLZ_45uJtF7l1Ejk5senIyO2nIkG9uHh_453zAP6SJdCgMeta } from "/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/index.vue?macro=true";
import { default as notes2o1jovcvSIPz0swC7MTTsabf3b5GGHhN_45vua9pYumwgMeta } from "/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/notes.vue?macro=true";
import { default as _91uuid_9310mmvJA7w_bUqlg3fTzqOm2mwdlLRyzKBiPlBLwhIfgMeta } from "/vercel/path0/apps/zefire-spa/pages/invoices/[uuid].vue?macro=true";
import { default as _91aggregation_9320juYNOVOJC4qj3L1xL2zGVW1D9MXJ6dHjh4QG6kxdAMeta } from "/vercel/path0/apps/zefire-spa/pages/metrics/[aggregation].vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/auth.vue"),
    children: [
  {
    name: "auth-action",
    path: ":action()",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/auth/[action].vue")
  }
]
  },
  {
    name: "error",
    path: "/error",
    meta: errorpyOG4L79B1TohYxt0Utn6s0GVK_45MKgmtE4JWPvLCudAMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/error.vue")
  },
  {
    name: "releases",
    path: "/releases",
    meta: releasesD7Tabir9XPWlVtB_45VEyPQz0Mg9Xnp1OjwgRNzXapxWoMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/releases.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsgGmu0TNotA8b2_wgp1njhdr6t8bz8RP_45nGDjLF_45HBtgMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/settings.vue")
  },
  {
    name: "companies",
    path: "/companies",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies.vue"),
    children: [
  {
    name: "companies-kind",
    path: ":kind()",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind].vue"),
    children: [
  {
    name: _91uuid_93n7UE7c_cgEDcGrcLvnFOMqOa_45qKalm26_452HUn8Nxs24Meta?.name,
    path: ":uuid()",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid].vue"),
    children: [
  {
    name: "companies-kind-uuid-files",
    path: "files",
    meta: filesIg6sAzck8i4U0KfETdAbN_gIGIpV16Ytf4c4_45GD1XHgMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/files.vue")
  },
  {
    name: "companies-kind-uuid",
    path: "",
    meta: indexiIkL6O36ja4AwvEfpKm6kR0BpQgzSHPBBOEsJo6m_sQMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/index.vue")
  },
  {
    name: "companies-kind-uuid-notes",
    path: "notes",
    meta: notestrSoePXuXQ9U8ZPNzPl6GlyTZiG19z_hLVjZdFQB9y0Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/notes.vue")
  },
  {
    name: "companies-kind-uuid-invoices",
    path: "invoices",
    meta: invoicescYXGxcNw52JmdEBfTxW0A_45p7vVbhVRKRgXSe6yQfa8cMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/invoices.vue")
  },
  {
    name: "companies-kind-uuid-contracts",
    path: "contracts",
    meta: contractswz_X4k9_45GUClR2KbB5jiCVVxBAw8mKKGKhl6eM_45kDnkMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/contracts.vue")
  },
  {
    name: "companies-kind-uuid-portfolio",
    path: "portfolio",
    meta: portfolioStHW4C0Z0v61pB5ZWH1bwAQPQ1sKSFBOogXVxv7sv7EMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/portfolio.vue")
  },
  {
    name: "companies-kind-uuid-datahealth",
    path: "datahealth",
    meta: datahealthgM8f18NpPue1Yx0WCBSS326FS1JjJ_VL3iKy2FQ2aW4Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/datahealth.vue")
  },
  {
    name: "companies-kind-uuid-supervision",
    path: "supervision",
    meta: supervisionyQ2oCimsz8El7sgveLuTFFbIIoh2eRouPWJKd_45ACIpcMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/supervision.vue")
  },
  {
    name: "companies-kind-uuid-aggregation",
    path: ":aggregation()",
    meta: _91aggregation_93_1SpDbAi5lWdzrV3h8l49mwdny8SMmP_45q_45b_6Sd2kuEMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/[aggregation].vue")
  },
  {
    name: "companies-kind-uuid-calendar-view",
    path: "calendar-:view()",
    meta: calendar_45_91view_93zKV0DRglaFKgP_OKG29BUaDlnvE9_45vOvWL_4543Y6I5HEMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/companies/[kind]/[uuid]/calendar-[view].vue")
  }
]
  }
]
  }
]
  },
  {
    name: contractsmYTrF_zcLrvEDtYZZM_CwwWRmY_tim5FcqDG5bH878sMeta?.name,
    path: "/contracts",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts.vue"),
    children: [
  {
    name: "contracts",
    path: "",
    meta: index1WV5dLjFGSTHSZLJDATLsjwLvzWqQGFgOAqEpGylls4Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/index.vue")
  },
  {
    name: _91uuid_93W9VrRIgzywV7ZfTWH4V9Zpu7VzqjhXaU277O29hB0bYMeta?.name,
    path: ":uuid()",
    meta: _91uuid_93W9VrRIgzywV7ZfTWH4V9Zpu7VzqjhXaU277O29hB0bYMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid].vue"),
    children: [
  {
    name: "contracts-uuid-files",
    path: "files",
    meta: filesosiVw0DgVPYqzTeybXCeCaBRvaDcvHmss_J_HoZpAEUMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/files.vue")
  },
  {
    name: "contracts-uuid",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/index.vue")
  },
  {
    name: "contracts-uuid-notes",
    path: "notes",
    meta: notesrfgptyMQRPySzE6UIqxfa1T0nbwLjgXR8K20v24SEMUMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/notes.vue")
  },
  {
    name: "contracts-uuid-invoices",
    path: "invoices",
    meta: invoicesmef8MdUJyJNn82_45bPM1_WHOhuG483rD0PCerlQqqr8QMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/invoices.vue")
  },
  {
    name: "contracts-uuid-supply-invoices",
    path: "supply-invoices",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/contracts/[uuid]/supply-invoices.vue")
  }
]
  }
]
  },
  {
    name: dashboardQ7IeIdoF2_45_45tEjeRKHvNPUvKbog2IALONuw0eHHNWhkMeta?.name,
    path: "/dashboard",
    meta: dashboardQ7IeIdoF2_45_45tEjeRKHvNPUvKbog2IALONuw0eHHNWhkMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-files",
    path: "files",
    meta: files14eb6u7WCAcJcGSX5DgltKemE1A0OifbxHzT9EUJTaYMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/files.vue")
  },
  {
    name: "dashboard",
    path: "",
    meta: indexpE6Mb607Ytj9_45FrxNydCZwAXdM9OIpnUWvGQcOgVJPUMeta || {},
    alias: ["/"],
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-notes",
    path: "notes",
    meta: notesQwb9XEL0N_i9qZWKQ_45EmYfpu8A28IpQinwo0aV7o46EMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/notes.vue")
  },
  {
    name: "dashboard-market",
    path: "market",
    meta: marketZHkiyQU4dztNYxbW_45vl2OXFEMYYI3wVweMPG430k3UYMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/market.vue")
  },
  {
    name: "dashboard-techno",
    path: "techno",
    meta: technoquGUQH27u9SsG3RsERvBtGMeDB4JhP6XLoDQN9WJQq4Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/techno.vue")
  },
  {
    name: "dashboard-datahealth",
    path: "datahealth",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/datahealth.vue")
  },
  {
    name: "dashboard-supervision",
    path: "supervision",
    meta: supervisionQBuBjWvDVfFbS347RNl9eoJmSj4LERmLiO1IYw8dtzMMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/supervision.vue")
  },
  {
    name: "dashboard-calendar-view",
    path: "calendar-:view()",
    meta: calendar_45_91view_93Uq5tJrtGJFLVqxEDn90GLAgOYbb_z9ICraYkat_bdiUMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/dashboard/calendar-[view].vue")
  }
]
  },
  {
    name: invoicingxOFO9sq_kVjWpie9eVu9oYDM9pFZoy_45_457pZl2_45v_451GQMeta?.name,
    path: "/invoicing",
    meta: invoicingxOFO9sq_kVjWpie9eVu9oYDM9pFZoy_45_457pZl2_45v_451GQMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoicing.vue"),
    children: [
  {
    name: "invoicing",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoicing/index.vue")
  },
  {
    name: "invoicing-invoices",
    path: "invoices",
    meta: invoicesayT315h5VV4UFlE7VXxw4gFar7BGAXGvmbojooYZG9MMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoicing/invoices.vue")
  },
  {
    name: "invoicing-recovery",
    path: "recovery",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoicing/recovery.vue")
  },
  {
    name: "invoicing-validation",
    path: "validation",
    meta: validationQcAfm5Wfe4dydEkb2_BYLt_45Xi3v0luuxQ92SUzZyTQIMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoicing/validation.vue")
  }
]
  },
  {
    name: portfolioRlWsfzRe3jJdk3DHoOSHnqV36lh1AeuDa_J75CMCgR8Meta?.name,
    path: "/portfolio",
    meta: portfolioRlWsfzRe3jJdk3DHoOSHnqV36lh1AeuDa_J75CMCgR8Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio.vue"),
    children: [
  {
    name: "portfolio",
    path: "",
    meta: indexKuWKWE9VlVmstfdql7ioXb_45NrWmktlG56ufnGz8YWnoMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/index.vue")
  },
  {
    name: _91uuid_93wtg3Pn6OSh7ml4sBOw0xI5rq2__g2ANDY_45pW6vPb_458oMeta?.name,
    path: ":uuid()",
    meta: _91uuid_93wtg3Pn6OSh7ml4sBOw0xI5rq2__g2ANDY_45pW6vPb_458oMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid].vue"),
    children: [
  {
    name: "portfolio-uuid-files",
    path: "files",
    meta: filesiZKXpHE8XTGjN3ZuYqPgPSNJi46GxXhTPmLvwUfo8lUMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/files.vue")
  },
  {
    name: "portfolio-uuid",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/index.vue")
  },
  {
    name: "portfolio-uuid-notes",
    path: "notes",
    meta: notesMFE8Nh3BD_JIwjbokrCCkS2zPrFhkuP9ULKi6hqEm2kMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/notes.vue")
  },
  {
    name: "portfolio-uuid-assets",
    path: "assets",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/assets.vue")
  },
  {
    name: "portfolio-uuid-invoices",
    path: "invoices",
    meta: invoicesAPrK9Oo5fEbS_45ue3CJXiVxKH2m_45GajlNAO_T3d62JbIMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/invoices.vue")
  },
  {
    name: "portfolio-uuid-contracts",
    path: "contracts",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/contracts.vue")
  },
  {
    name: "portfolio-uuid-datahealth",
    path: "datahealth",
    meta: datahealthEEsRKBrl6LG6yh1Iy5vUA4BOWIXViYK0PwI8aOUIa3AMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/datahealth.vue")
  },
  {
    name: "portfolio-uuid-datastatus",
    path: "datastatus",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/datastatus.vue")
  },
  {
    name: "portfolio-uuid-supervision",
    path: "supervision",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/supervision.vue")
  },
  {
    name: "portfolio-uuid-calendar-view",
    path: "calendar-:view()",
    meta: calendar_45_91view_9343_HfezvrDS7xaAWK6QrRmalsG55TdZB0X1uXGCweREMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/calendar-[view].vue")
  },
  {
    name: "portfolio-uuid-supply-invoices",
    path: "supply-invoices",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/portfolio/[uuid]/supply-invoices.vue")
  }
]
  }
]
  },
  {
    name: "datastudio",
    path: "/datastudio",
    meta: datastudiolJf0_450wjsEPumffG1zElW7Y0Ur7FUQLSPisBbccO1NoMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/datastudio.vue")
  },
  {
    name: "ui-testing",
    path: "/ui-testing",
    meta: ui_45testingEXYvUNmJxYctMxqc5zHl_45y2TA_cncxwx8cVwXRqIJ80Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/ui-testing.vue")
  },
  {
    name: marketplaceT2KBnNIzYsojjg2HFmFGmeaAfcQZ9J93Uzx4NgHPEBYMeta?.name,
    path: "/marketplace",
    meta: marketplaceT2KBnNIzYsojjg2HFmFGmeaAfcQZ9J93Uzx4NgHPEBYMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-counterparts",
    path: "counterparts",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/marketplace/counterparts.vue")
  }
]
  },
  {
    name: commissioning47Vn0MNdQTpgx25FSYvTIMsiM6vT207WN9RfTc2S7H0Meta?.name,
    path: "/commissioning",
    meta: commissioning47Vn0MNdQTpgx25FSYvTIMsiM6vT207WN9RfTc2S7H0Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/commissioning.vue"),
    children: [
  {
    name: "commissioning",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/commissioning/index.vue")
  },
  {
    name: "commissioning-reserves",
    path: "reserves",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/commissioning/reserves.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexET7Kmiwzj8kIbZECU54hL0SrNYR612LDZANXMnaEUekMeta || {},
    redirect: indexET7Kmiwzj8kIbZECU54hL0SrNYR612LDZANXMnaEUekMeta?.redirect,
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoices/index.vue")
  },
  {
    name: _91uuid_9310mmvJA7w_bUqlg3fTzqOm2mwdlLRyzKBiPlBLwhIfgMeta?.name,
    path: "/invoices/:uuid()",
    meta: _91uuid_9310mmvJA7w_bUqlg3fTzqOm2mwdlLRyzKBiPlBLwhIfgMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoices/[uuid].vue"),
    children: [
  {
    name: "invoices-uuid-files",
    path: "files",
    meta: filesTyuxjG1CTOlsTvHfoOkAtq5WHLL2DejapuYYlnveyK0Meta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/files.vue")
  },
  {
    name: "invoices-uuid",
    path: "",
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/index.vue")
  },
  {
    name: "invoices-uuid-notes",
    path: "notes",
    meta: notes2o1jovcvSIPz0swC7MTTsabf3b5GGHhN_45vua9pYumwgMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/invoices/[uuid]/notes.vue")
  }
]
  },
  {
    name: "metrics-aggregation",
    path: "/metrics/:aggregation()",
    meta: _91aggregation_9320juYNOVOJC4qj3L1xL2zGVW1D9MXJ6dHjh4QG6kxdAMeta || {},
    component: () => import("/vercel/path0/apps/zefire-spa/pages/metrics/[aggregation].vue")
  }
]